import { render, staticRenderFns } from "./display-fallback.vue?vue&type=template&id=2be41444&"
import script from "./display-fallback.vue?vue&type=script&lang=js&"
export * from "./display-fallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports